module.exports = __webpack_public_path__ + "static/media/cat.8aa39a3b.png";